import { Component, Input } from '@angular/core';


import { PCardTableModel } from '../../models/pcard-table-model';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-pcard-table',
  templateUrl: './pcard-table.component.html',
  styleUrls: ['./pcard-table.component.css']
})

export class PCardTableComponent {
  constructor(private logger: LoggerService) {

  }

  @Input() tableOption!: PCardTableModel;


}
